
import { useParams } from "react-router-dom";
import CareerInfo from "../components/career/CareerInfo";
import TopTitle from "../components/TopTitle";
import data from "../constants/careers.json";

const CAREERS = {
  "administracion-de-empresas": 0,
  "administracion-de-personal": 1,
  "administracion-de-sistemas-de-mantenimiento": 2,
  "administracion-tributaria": 3,
  "higiene-y-seguridad-industrial": 4,
  "informatica": 5,
  "logistica-industrial": 6,
  "tecnologia-de-gas": 7,
  "tecnologia-instrumentista": 8,
  "tecnologia-petrolera": 9
}

function Career() {
  const params = useParams();
  const career = data[CAREERS[params.id]];
  const image = require(`../assets/img/${career.id}.jpg`);

  return (
    <div className="main-content">
      <TopTitle title={career.name} />
      <section className="bg-light py-4">
        <div className="container">
          <div className="row align-items-center justify-content-center py-2">
            <CareerInfo career={career} image={image} />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Career;
